import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { of, Subscription, Subject } from 'rxjs';
import { tap, map, switchMap, finalize } from 'rxjs/operators';
import { FilterService } from 'primeng/api';
import { Title } from "@angular/platform-browser";
import { Table, TableFilterEvent } from 'primeng/table';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocListEntry } from 'src/app/shared/doc-list-entry';
import { RestApiService } from 'src/app/services/rest-api.service';

@Component({
  selector: 'app-home-recent-orders-list',
  templateUrl: './home-recent-orders-list.component.html',
  styleUrls: ['./home-recent-orders-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeRecentOrdersListComponent implements OnInit, OnDestroy, OnChanges {

  @Input() today: Date = new Date();
  @Input() clean: boolean = true;

  globalSettinsData: GlobalSettingsData;

  showProformaDocuments: boolean = false;
  recentOrdersList: DocListEntry[] = [];
  recentSelectedDocument: DocListEntry = null;
  recentOrdersQuery: Subscription = null;
  totalRecentOrders: number = 0;

  loading: boolean = false;

  totalInvoiceSum: number = 0;
  totalPaidSum: number = 0;
  totalShippedSum: number = 0;

  @ViewChild('ptable1') ptable1: Table;

  cf1: any = {};    // to store f[string] filters value

  constructor(
    private restapi: RestApiService,
    private filterService: FilterService,
    private globalsettingsservice: GetglobalsettingsService,
    private titleService: Title,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    console.log('*** HomeRecentOrdersListComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      switch (propName) {
        case 'clean':
          this.clearSavedSettings();

        case 'today':
          this.loadRecentOrdersData();
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log("*** HomeRecentOrdersListComponent in ngOnDestroy");

    if (this.recentOrdersQuery) { this.recentOrdersQuery.unsubscribe(); }
  }

  ngOnInit(): void {
    console.log("*** HomeRecentOrdersList Component in ngOnInit");
    this.titleService.setTitle('Недавние заказы - домашняя страница');

    this.today = new Date();

    console.log('*** Home in onInit: ' + JSON.stringify(this.today));

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.loadRecentOrdersData();
  }

  docListCalculatedFields(orderList: DocListEntry[]) {

    let jn: Date = new Date();
    let td: Date = new Date();
    td.setHours(0, 0, 0, 0);
    let tm: Date = new Date(td);
    tm.setHours(23, 59, 59);

    orderList.forEach((dc: DocListEntry) => {
      dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

      dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

      dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

      dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

      dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

      dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

      dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

      dc.fd = (new Date(dc.DOCDATE) > tm);
    });
  }

  loadRecentOrdersData(): void {
    if (this.globalSettinsData) {
      this.loading = true;
      this.recentOrdersQuery =
        of({ mc: this.globalSettinsData.mainCompanyId, depth: 1, date: this.today, flag: this.showProformaDocuments })
        .pipe(
          switchMap(opt => this.restapi.getRecentOrdersList(opt.mc, opt.depth, opt.date, opt.flag).pipe(

            tap(data => { if (!environment.production) console.table(data); }),

            map(data => this.recentOrdersList = data || []),

            finalize(() => {
              this.totalRecentOrders = this.recentOrdersList.length;
              this.docListCalculatedFields(this.recentOrdersList);
              this.totalInvoiceSum = this.recentOrdersList.reduce((s, e) => s += e.DOCSUM, 0);
              this.totalPaidSum = this.recentOrdersList.reduce((s, e) => s += e.PAYDSUM, 0);
              this.totalShippedSum = this.recentOrdersList.reduce((s, e) => s += e.SHIPSUM, 0);
              this.loading = false;
            })
          )))
        .subscribe({
          error: (err) => {
            console.log('*** HomeRecentOrdersListComponent in loadRecentOrdersData error: ' + JSON.stringify(err));
            this.loading = false;
          }
        });
    }
  }

  onFilterEvent(event: TableFilterEvent) {
    console.log('*** HomeRecentOrdersListComponent onFilterEvent: ' + JSON.stringify(event));

    this.totalInvoiceSum = event.filteredValue.reduce((s, e) => s += e.DOCSUM, 0);
    this.totalPaidSum = event.filteredValue.reduce((s, e) => s += e.PAYDSUM, 0);
    this.totalShippedSum = event.filteredValue.reduce((s, e) => s += e.SHIPSUM, 0);
  }

  onChangeRecentOrdersType(event) {
    console.log('*** HomeRecentOrdersListComponent in onChangeRecentOrdersType');
    console.log(event);
    //    this.showProformaDocuments = event.checked;
    this.loadRecentOrdersData();
  }

  onRecentRowSelect(event) {
    //console.log('*** DocumentsComponent onRowSelect: ' + JSON.stringify(event.data))
    //this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCID });
    //    this.messageService.add({ severity: 'info', summary: 'DocumentsComponent Selected', detail: event.data.DOCTYPEID });

    //this.selectedDocumentId = event.data.DOCID;
    //if (this.selectedDocumentId) {
    //  //this.doLoadDataItems(this.selectedDocumentId);
    //}
  }

  onStateSave(state) {
    console.log('*** HomeRecentOrdersListComponent onStateSave: ' + JSON.stringify(state));
  }

  onStateRestoreNew(state) {
    console.log('*** HomeRecentOrdersListComponent onStateRestoreNew: ' + JSON.stringify(state));
    if (state.filters) {
      for (let f in state.filters) {
        let fltItem = state.filters[f];
        this.cf1[f] = Array.isArray(fltItem) ? fltItem[0].value : fltItem.value;
      }
    }
  }

  clearSavedSettings() {
    console.log('*** HomeRecentOrdersListComponent in clearSavedSettings: ' + this.clean);
    try {
      this.ptable1.clearState();
    } catch (e) {
      console.log('*** HomeRecentOrdersListComponent in clearSavedSettings: ' + JSON.stringify(e));
    }
    this.clean = false;
  }

  reloadTable(event) {
    console.log('*** HomeRecentOrdersListComponent reloadTable: ' + JSON.stringify(event));

    this.loadRecentOrdersData();
  }

  clearOrResetTableFilter(event) {
    console.log('*** HomeRecentOrdersListComponent clearOrResetTableFilter: ' + JSON.stringify(event));

    this.clearSavedSettings();
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });

      saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  onExportData() {
    console.log('*** HomeRecentOrdersListComponent onExportData: ')

    import("xlsx").then(xlsx => {

      environment.production || console.table(this.recentOrdersList);

      const exportData: any =
        this.recentOrdersList.map(e => ({

          'Документ': e.DOCNAME,
          'Номер': e.DOCNUMBER,
          'Дата': new Date(e.DOCDATE),
          'Покупатель': e.CLIENTSNAME,
          'Ответственный': e.PERSONNAME,
          'Продавец': e.LOCALCOMP,
          'Менеджер': e.AUTHOR,
          'Сумма': e.DOCSUM,
          'Оплачено': e.PAYDSUM,
          'Отгружено': e.SHIPSUM,
          'Валюта': e.CURSTR,
          'Курс': e.DOCRATEVAL,
          'Примечание продавца': e.DOCNOTE1,
          'Примечание покупателя': e.DOCNOTE2,

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { documents: worksheet }, SheetNames: ['documents'] };

      const excelBuffer: any = xlsx.write(workbook, { bookType: "xlsx", type: "array" });

      this.saveAsExcelFile(excelBuffer, "documents");
    });
  }
}
